/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Thumbnail_Drop_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Drop failed: {error}" |
*
* @param {Explorer_Thumbnail_Drop_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_drop_failed_toast = /** @type {((inputs: Explorer_Thumbnail_Drop_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Drop_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Deposer echoue : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Abwurf fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rilascio fallito: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при сбросе: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Fallo en la entrega: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`掉落失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ドロップに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ड्रॉप विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha na queda: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Drop failed: ${i?.error}`)
});